import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

const container = document.getElementById('root');
createRoot(container!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
